import { render, staticRenderFns } from "./OneClickPrice.vue?vue&type=template&id=4372412c&scoped=true&"
import script from "./OneClickPrice.vue?vue&type=script&lang=js&"
export * from "./OneClickPrice.vue?vue&type=script&lang=js&"
import style0 from "./OneClickPrice.vue?vue&type=style&index=0&id=4372412c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372412c",
  null
  
)

export default component.exports